import { Button } from "@svea/design-system-components-react";
import {
	Condition,
	FormWithTracking,
	isRequired,
	normalizeSsn,
	RadioGroupField,
	Stack,
	TextField,
	trim,
	useLogin,
	useText,
	validateSsn,
} from "@sveabank/cc-common";
import { useDispatch } from "react-redux";
import { handleLoginError } from "./helpers";

type LoginFormValues = {
	ssn: string;
	mode: "fake" | "test";
};

const LoginDev = () => {
	const dispatch = useDispatch();
	const { doLogin, loginState } = useLogin();

	const submitLoginForm = async ({ ssn, mode }: LoginFormValues) => {
		if (mode === "fake") {
			doLogin(false, "FAKE", normalizeSsn(ssn)).catch((e) => handleLoginError(e, dispatch));
		} else {
			doLogin(false, "TEST").catch((e) => handleLoginError(e, dispatch));
		}
	};
	const [t, texts] = useText();

	return (
		<FormWithTracking<LoginFormValues>
			onSubmit={submitLoginForm}
			initialValues={{ mode: "fake" }}
			matomoInstance={window.Matomo}
			render={({ handleSubmit }) => (
				<form name="signInForm" onSubmit={handleSubmit}>
					<Stack gap={8}>
						<RadioGroupField
							direction="row"
							name="mode"
							options={[
								{
									label: "Fake",
									value: "fake",
								},
								{
									label: "Test",
									value: "test",
								},
							]}
							initialValue="fake"
						/>
						<Condition when="mode" is="fake" fieldName="ssn">
							<TextField
								label={t(texts.loginPage.loginForm.ssn)}
								type="tel"
								name="ssn"
								parse={trim}
								validators={[isRequired, validateSsn]}
								helperText={t(texts.common.ssnFormat)}
							/>
						</Condition>
						<Button
							isDisabled={loginState === "PENDING"}
							type="submit"
							data-testid="bankidButton"
							width="full"
						>
							{t(texts.loginPage.buttonTextOtherDevice)}
						</Button>
					</Stack>
				</form>
			)}
		/>
	);
};

export default LoginDev;
